export function isInDarkMode() {
  const darkModeValue = sessionStorage.getItem("darkMode");
  return !["f", "false", "0", "", null].includes(darkModeValue);
}
